/**
 * Base dataLayer object for Adobe Analytics
 * @param {object} cart - completed cart object
 * @returns {object} - base dataLayer object
 */
export default (cart) => ({
	account: cart.app.env === 'prod' ? 'symanteccom' : 'veritasdev',
	site_country: cart.url.region,
	site_language: cart.url.language,
	content_title: document.title,
	content_format: 'html',
	content_type: 'page',
	userflow: cart.url.brand,
	site_section: `checkout ${cart.url.brand}`,
	site_sub_section: 'cart',
	store_cartdesign: `${cart.theme?.name || null}-${cart.order?.flow || null}`,
	spa: true,
	// New params for eStore vs Api cart test
	store_ecomaction: cart.url.query.ecommerceaction?.string,
	promoid: cart.url.query.promocode?.string,
	store_incpsn: cart.url.query.psn?.string,
	incoming_product_SKU: cart.url.query.skup?.string,
	origin: cart.url.query.origin?.string,
	campaignmarker: cart.url.query.campaignMarker?.string,
	clientid: cart.url.query.clientid?.string,
	'installation-guid': cart.url.query.installationguid?.string,
	'ipm-session-id': cart.url.query['ipm-session-id']?.string,
	ipm_test: cart.url.query.ipmtest?.string,
	ipm_content_id: cart.url.query.ipmcontent?.string,
	tsplitid: cart.url.query.tsplitid?.string
});
